import { type MutationHookOptions, useMutation } from "@apollo/client";
import { ConnectCCBillMutation } from "../graphql/mutations";
import type {
  ConnectCcBillMutationType,
  ConnectCcBillMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useConnectCCBillMutation = (
  options?: MutationHookOptions<
    ConnectCcBillMutationType,
    ConnectCcBillMutationVariablesType
  >
) => {
  return useMutation<
    ConnectCcBillMutationType,
    ConnectCcBillMutationVariablesType
  >(ConnectCCBillMutation, options);
};
